// Taken from
// https://www.jpwilliams.dev/how-to-unpack-the-return-type-of-a-promise-in-typescript

/**
 * Unwrap extracts the actual type of the Promise.
 */
export type UnwrapPromise<T> = T extends Promise<infer U> ? U : T;
